import { A } from '@adornis/base/env-info.js';
import { delay } from '@adornis/bh-util/util.js';
import {
  exportWorkshopParticipantsCSV,
  ikh_exportWorkshopParticipantsInvoices,
} from '@adornis/buchungsheld-db/api/workshop.js';
import type { WorkshopParticipationExportPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
const _XNativeDialog = () => import('@adornis/dialog/x-native-dialog.js').then(m => m.XNativeDialog);
import { downloadLink } from '@adornis/file-utils/client/helper-methods.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';

export const ikhWorkshopParticipationExportPlugin: WorkshopParticipationExportPlugin = {
  id: 'workshop-participation-export::ikh',
  type: 'workshop-participation-export',
  render: (
    host: ChemistryLitElement,
    translation: TranslationController<BHTranslationDictionary>,
    institutionID: string,
    workshop,
  ) => html`
    <x-flex space="md">
      <x-h3> Import / Export </x-h3>
      <div space="md">
        <x-button
          mode="outline"
          icon="download"
          @click=${async () => {
            try {
              await (await _XNativeDialog()).waitFor(
                Promise.all([
                  exportWorkshopParticipantsCSV(workshop._id, false)().then(fileName =>
                    downloadLink(A.absoluteUrl(`/__export/download/${fileName}`), 'teilnehmer.csv'),
                  ),
                  delay(500),
                ]),
              );
            } catch (e) {
              await (await _XNativeDialog()).alert(translation.translate('workshop', 'export_err'));
            }
          }}
        >
          ${translation.translate('imp_exp', 'exp_participants')}
        </x-button>

        <br />
        <br />
        <br />
        <x-h4> mit erfolgreicher Teilnahme</x-h4><br />

        <!-- intern participated -->
        <x-button
          mode="outline"
          icon="download"
          @click=${async () => {
            try {
              await (await _XNativeDialog()).waitFor(
                Promise.all([
                  exportWorkshopParticipantsCSV(workshop._id, true, '{"invoiceReceiver": "IKHINTERNAL"}')().then(
                    fileName =>
                      downloadLink(A.absoluteUrl(`/__export/download/${fileName}`), 'teilnehmer-intern-bestanden.csv'),
                  ),
                  delay(500),
                ]),
              );
            } catch (e) {
              if ((e as any).message === 'file is empty') {
                await (await _XNativeDialog()).alert(translation.translate('imp_exp', 'no_data_found'));
              } else {
                await (await _XNativeDialog()).alert(translation.translate('workshop', 'export_err'));
              }
            }
          }}
        >
          Interne Teilnehmer exportieren
        </x-button>

        <!-- extern participated -->
        <x-button
          mode="outline"
          icon="download"
          @click=${async () => {
            try {
              await (await _XNativeDialog()).waitFor(
                Promise.all([
                  exportWorkshopParticipantsCSV(workshop._id, true, '{"invoiceReceiver": "IKHEXTERNAL"}')().then(
                    fileName =>
                      downloadLink(A.absoluteUrl(`/__export/download/${fileName}`), 'teilnehmer-extern-bestanden.csv'),
                  ),
                  delay(500),
                ]),
              );
            } catch (e) {
              if ((e as any).message === 'file is empty') {
                await (await _XNativeDialog()).alert(translation.translate('imp_exp', 'no_data_found'));
              } else {
                await (await _XNativeDialog()).alert(translation.translate('workshop', 'export_err'));
              }
            }
          }}
        >
          Externe Teilnehmer exportieren
        </x-button>

        <!-- extern invoices  -->
        <x-button
          mode="outline"
          icon="download"
          @click=${async () => {
            try {
              await (await _XNativeDialog()).waitFor(
                Promise.all([
                  ikh_exportWorkshopParticipantsInvoices(workshop._id)().then(fileName =>
                    downloadLink(A.absoluteUrl(`/__export_general/download/${fileName}`), 'rechnungen-extern.zip'),
                  ),
                  delay(500),
                ]),
              );
            } catch (e) {
              if ((e as any).message === 'file is empty') {
                await (await _XNativeDialog()).alert(translation.translate('imp_exp', 'no_data_found'));
              } else {
                await (await _XNativeDialog()).alert(translation.translate('workshop', 'export_err'));
              }
            }
          }}
        >
          Externe Rechnungen exportieren
        </x-button>
      </div>
    </x-flex>
  `,
};
